<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title">
                                <span class="index">
                                    <i class="soap-icon-star circle"></i>
                                </span>
                                {{ titleinfo[getCurrentLocale] }}
                            </h1>
                        </div>
                        <br />
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="servicesonboard_h4_1[getCurrentLocale]"></h4>

                            <!-- <p v-html="servicesonboard_p_0[getCurrentLocale]"></p> -->
                            <p v-html="servicesonboard_p_1[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_2[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_3[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_4[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_5[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_6[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_7[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_8[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_9[getCurrentLocale]"></p>
                            <p v-html="servicesonboard_p_10[getCurrentLocale]"></p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->

        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Important information:',
                    de: 'Wichtige Hinweise:',
                },
                // >>> --------------------------
                servicesonboard_h4_1: {
                    en: 'Important infomation for seat and special reservations',
                    de: 'Wichtige Hinweise für Sitzplatz- und Servicereservierung',
                },
                servicesonboard_p_0: {
                    en: '<strong>Please note:</strong><br />Seats A + C on the left side of the cabin on the MD82 are directly next to each other. The seat designation B is not used.',
                    de: '<strong>Bitte beachten Sie:</strong><br />Sitzplätze A + C auf der linken Kabinenseite beim Maschinentyp MD82 liegen unmittelbar nebeneinander. Die Sitzplatzbezeichnung B wird nicht verwendet.',
                },
                // >>> --------------------------
                servicesonboard_p_1: {
                    en: '<strong>1.</strong> Seat reservations are possible only for firm bookings up to seven (7) days / 168 Hours before departure. Special/excess baggage must be registered with European Air Charter before the flight. All option bookings will be cancelled in principle.<br /><br />Special/excess baggage must be registered before the flight. Information on this can be found on our website https://euaircharter.com/de/nutzliche-info/. All option bookings are always cancelled.',
                    de: '<strong>1.</strong> Sitzplatzreservierungen sind nur für Festbuchungen bis sieben (7) Tage / 168 Stunden vor Abflug möglich. Sonder-/ und Übergepäck muss vor dem Flug bei European Air Charter angemeldet werden. Alle Optionsbuchungen werden grundsätzlich storniert.<br /><br />Sonder-/ und Übergepäck muss vor dem Flug angemeldet werden. Informationen hierzu finden Sie auf unserer Internetseite https://euaircharter.com/de/nutzliche-info/. Alle Optionsbuchungen werden grundsätzlich storniert.',
                },
                servicesonboard_p_2: {
                    en: '<strong>2.</strong> Please note that rows 2 to 5 are for families with small children (under 2 years old) and passengers with reduced mobility. Seats 30 AC are excluded from online reservation.',
                    de: '<strong>2.</strong> Wir bitten um Beachtung, dass die Reihen 2 bis 5 für Familien mit Kleinkindern (unter 2 Jahren) und Fluggäste mit Mobilitätseinschränkung vorgesehen sind. Die Sitzplätze 30 AC sind von der Online- Reservierung ausgeschlossen.',
                },
                servicesonboard_p_3: {
                    en: '<strong>3.</strong> Children, up to the age of two (2) are considered "infants" (INF) and are not entitled to their own seat. Please keep in mind that only one infant is allowed in each row. Infants cannot sit in the front row.',
                    de: '<strong>3.</strong> Kinder, bis zum zweiten (2.) Lebensjahr gelten als "Kleinkinder" (INF) und haben nicht das Recht auf einen eigenen Sitzplatz. Bitte berücksichtigen Sie, dass in jeder Reihe nur  ein Kleinkind erlaubt ist. Kleinkinder können nicht in der ersten Reihe sitzen.',
                },
                servicesonboard_p_4: {
                    en: '<strong>4.</strong> Seat reservations for guests with mobility restrictions can only be made in writing directly to European Air Charter at eMail: info@euaircharter.com. Children under the age of 2 are not entitled to a seat.',
                    de: '<strong>4.</strong> Sitzplatzreservierungen für Gäste mit Mobilitätseinschränkungen können nur schriftlich direkt bei European Air Charter unter der eMail: info@euaircharter.com vorgenommen werden. Kinder bis zum vollendeten 2. Lebensjahr haben keinen Sitzplatzanspruch.',
                },
                servicesonboard_p_5: {
                    en: '<strong>5.</strong> Please note that the following group of people - due to security requirements imposed by the authorities - cannot book XL seats (exit row at the emergency exit and 1. Row):<br />- Babies and children under the age of 16 <br />- Persons carrying animals in the cabin <br />- expectant mothers<br />- physically and/or mentally handicapped persons <br />- Persons who are restricted in mobility due to their body size, illness or for reasons of age <br />- Accompanying person of a passenger who needs help in an emergency situation (e.g. small child/child) <br />- People who cannot understand, speak or read either German or English <br /><br />In addition, the use of an extension belt is not permitted in the emergency exit rows.<br /><br />With the reservation at the emergency exit, you assure that these criteria do not apply to you and the people you have booked and that you will support the cabin crew in the event of an emergency. Should the opposite occur, the airline is entitled to allocate the person(s) concerned to another seat without refunding the handling fee. In case of doubt, the cabin crew will make the decision.',
                    de: '<strong>5.</strong> Bitte beachten Sie, dass folgender Personenkreis - bedingt durch Sicherheitsauflagen der Behörden - keine XL-Seats buchen kann (Exit Reihe am Notausgang und 1. Reihe):<br />- Babys und Kinder unter 16 Jahren <br />- Personen, die Tiere in der Kabine mitführen <br />- werdende Mütter <br />- körperlich und/oder geistig behinderte Personen <br />- Personen, die durch ihre Körpermaße, Krankheit oder aus Altersgründen eingeschränkt beweglich sind <br />- Begleitperson eines Passagiers, der in einer Notsituation auf Hilfe angewiesen ist (z.B. Kleinkind/Kind) <br />- Personen, die weder die deutsche noch die englische Sprache verstehen, sprechen oder lesen können <br />- Darüber hinaus ist die Benutzung eines Verlängerungsgurtes (Extension-Belt) in den Notausgangsreihen nicht gestattet.<br /><br />Mit der Reservierung am Notausgang sichern Sie zu, dass diese Kriterien für Sie und die von Ihnen gebuchten Personen nicht zutreffen und Sie im Falle einer Notsituation die Kabinenbesatzung unterstützen. Sollte gegenteilige Fall eintreffen, ist die Fluggesellschaft berechtigt, der/den betreffenden Person(en) ohne Rückerstattung der Bearbeitungsgebühr einen anderen Sitzplatz zuzuweisen. Im Zweifelsfall trifft das Kabinenpersonal die Entscheidung.',
                },
                servicesonboard_p_6: {
                    en: '<strong>6.</strong> Information about the free baggage allowance for checked baggage can be found in the reservation or confirmation email from your tour operator. Please adhere to this specification. 6 kg of hand baggage per person is free. Excess baggage is subject to a fee per kg and flight leg. You can find the fee table on our website https://euaircharter.com/de/nutzliche-info/.',
                    de: '<strong>6.</strong> Informationen über die Freigepäckmenge für aufgegebenes Gepäck finden Sie in der Reservierungs- oder Bestätigungs-E-Mail Ihres Reiseveranstalters. Bitte halten Sie sich an diese Vorgabe. 6 kg Handgepäck pro Person sind frei. Für Übergepäck wird eine Gebühr pro Kg und Flugstrecke erhoben. Die Gebührentabelle finden Sie auf unserer Internetseite https://euaircharter.com/de/nutzliche-info/.',
                },
                servicesonboard_p_7: {
                    en: '<strong>7.</strong> Please note the correct spelling of the first and last name and compare it with the booking confirmation of your tour operator. Necessary corrections are to be made if necessary.',
                    de: '<strong>7.</strong> Bitte beachten Sie die korrekte Schreibweise des Vor- und Nachnamens und vergleichen Sie diese mit der Buchungsbestätigung Ihres Reiseveranstalters. Notwendige Korrekturen sind ggf. vorzunehmen.',
                },
                servicesonboard_p_8: {
                    en: '<strong>8.</strong> European Air Charter does not guarantee your reservations. In the rare case of a carrier change, the use of a different aircraft type or other important reasons, European Air Charters check-in staff and cabin crew may assign other seats to passengers.',
                    de: '<strong>8.</strong> European Air Charter übernimmt keine Garantie für Ihre Reservierungen. Im seltenen Falle eines Carrier - Wechsels, dem Einsatzes eines anderen Flugzeugmusters oder anderer wichtiger Gründe kann das Check-In Personal und das Kabinenpersonal der European Air Charter den Passagieren andere Sitzplätze zuweisen.',
                },
                servicesonboard_p_9: {
                    en: '<strong>9.</strong> For registration of other services, such as special luggage, special meals and transportation of pets, please visit our website: https://euaircharter.com. and the Berlin office of European Air Charter.',
                    de: '<strong>9.</strong> Für die Anmeldung weiterer Service, wie z.B. Sondergepäck, Sonderessen und Beförderung von Haustieren steht Ihnen unsere Internetpräsenz: https://euaircharter.com sowie die Berliner Vertretung der European Air Charter zur Verfügung.',
                },
                servicesonboard_p_10: {
                    en: '<strong>10.</strong> There will be no refunds for paid registrations.',
                    de: '<strong>10.</strong> Es erfolgt keine Erstattung von kostenpflichtigen Anmeldungen.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
a[target='_blank']:after {
    font-family: 'FontAwesome';
    content: ' \f08e';
}

/* >>>  iPAD -------------------------------------------------------------*/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    h1 {
        font-size: 1.6em;
    }
    .booking-information {
        padding: 20px 30px 30px;
        padding-top: 20px;
        padding-right: 15px;
        padding-bottom: 30px;
        padding-left: 15px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/infos/serviceonboard/Home.vue